import React from "react";
import { Switch, Route } from "react-router-dom";
import Home from "../components/pages/Home";
import Navigation from "../components/subcomponents/home/Navigation";

export default (
    <Switch>
        <Route exact path="/:accessKey?" component={Home} />
        <Route
            exact
            path="/:accessKey?/newsletter/:groupingId?"
            component={Home}
        />
        <Route
            exact
            path="/:accessKey?/newsletter/:groupingId?/archive/:date?"
            component={Home}
        />
        <Route
            exact
            path="/:accessKey?/newsletter/:groupingId?/temporary/:date?/:newsletterTempId?"
            component={Home}
        />
        <Route path="/" component={Home} />
    </Switch>
);
